import React from 'react';
import Layout from './Layout';
import { Redirect } from 'react-router-dom';
import { Route } from 'react-router';
import Connection from '../Connection';
import SigninWithQrCode from '../SigninWithQrCode';
import { compose } from 'recompose';
import Grid from '@material-ui/core/Grid'
import Admin from '../Admin';
import HealthCheck from '../../pages/HealthCheck'
import { getSession, getSsoReady } from '../../selectors/authentication';
import { resolveWorkspaceRoute, ROUTE_WORKSPACE, ROUTE_SIGN_IN } from '../../auth/session';
import { isAuthenticated } from '../../auth/keycloak';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ShowroomBanner } from '../../widgets/ShowroomBanner/ShowroomBanner';
import Header from '../../widgets/Header/Header';

// Routing is driven by the signed-in state (authentication.session):
// signed in → the sign-in pages redirect to the workspace; signed out → /admin redirects to `/`
// once the silent Keycloak check is over (so the Keycloak callback on /admin is not lost). A Keycloak
// session opens the workspace only while keycloak-js holds a token (never on the storage mirror alone).
const App = ({ session, ssoReady }) => {
    const signInPage = (Page) => () => (session ? <Redirect to="/admin" /> : <Page />);
    const renderAdmin = () => {
        const route = resolveWorkspaceRoute(session, ssoReady, isAuthenticated());
        if (route === ROUTE_WORKSPACE) {
            return <Admin session={session} />;
        }
        return route === ROUTE_SIGN_IN ? <Redirect to="/" /> : null;
    };
    return (
        <Grid container>
            <Header />
            <ShowroomBanner />
            <Layout />
            <Grid className="materialBaseGrid" item sm={12} style={{ minHeight: 1, maxWidth: '100%', width: '100%' }}>
                <Route exact path='/' render={signInPage(Connection)} />
                <Route exact path='/qr-code' render={signInPage(SigninWithQrCode)} />
                <Route exact path='/connect' render={signInPage(Connection)} />
                <Route exact path='/admin' render={renderAdmin} />
                <Route exact path='/info' component={HealthCheck} />
            </Grid>
        </Grid>
    );
}
const mapStateToProps = createStructuredSelector({
    session: getSession,
    ssoReady: getSsoReady,
})
export const enhance = compose(
    connect(mapStateToProps, null)
)
export default enhance(App);
